module.exports = __webpack_public_path__ + "static/media/selectArrowIconHome.487e4571.svg";